/**
 * @generated SignedSource<<d3181a80a2726f491e595b1fba357473>>
 * @relayHash b5a4c042fc7c8170b7b7c46c7a855329
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8bf840079d563a61ce5dcb8c5b2cd440c01798498f4b757d2c3eda4590f2eeb2

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { ui_jiraCalendarQuery } from './ui_jiraCalendarQuery.graphql';

const node: PreloadableConcreteRequest<ui_jiraCalendarQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "8bf840079d563a61ce5dcb8c5b2cd440c01798498f4b757d2c3eda4590f2eeb2",
    "metadata": {},
    "name": "ui_jiraCalendarQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
